import { Component, OnInit } from '@angular/core';

import { FormGroup, FormBuilder, FormControl, NgForm } from '@angular/forms';

import { Router, ActivatedRoute } from '@angular/router';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { NotificationService } from 'src/app/Service/notification.service';

import { OtherService } from 'src/app/Service/other.service';

import Chart from 'chart.js/auto';

import zoomPlugin from 'chartjs-plugin-zoom';

import { registerables } from 'chart.js';

import axios from 'src/app/Service/axios';

import * as XLSX from 'xlsx';

import { pluck } from 'rxjs';

@Component({

  selector: 'app-trip-status',

  templateUrl: './trip-status.component.html',

  styleUrls: ['./trip-status.component.css']

})

export class TripStatusComponent implements OnInit {

  chart1: any;

  chart2: any;

  lst_Domain: any[] = [];

  list_Trips = [];

  list_Trips_Search = [];

  bCharts: boolean = false;

  CHART_COLORS3: any = {

    green: 'rgb(111, 255, 111)',

    purple: 'rgb(255, 153, 204)',

    blue: 'rgb(29, 179, 214)',

    orange: 'rgb(45, 103, 103)',

    yellow: 'rgb(251, 101, 150)',

    red: 'rgb(36, 123, 46)',

    grey: 'rgb(103, 13, 183)',

  };

  trip_Obj = {

    iTotal: 0, // تعداد کل

    iRegistered: 0, // ثبت شده	

    iConfirmed: 0, // تایید شده		

    iDriverAssignment: 0, // اختصاص راننده		

    iInProgress: 0, // در حال انجام		

    iDdone: 0, // انجام‌شده		

    iCanceled: 0, // لغو شده		

    iMission: 0, // ماموریتی

  }

  searchModel: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strSDate: new FormControl(''),

    strEDate: new FormControl(''),

    iMobileDomain: new FormControl('-1'),

    tiAppUsage: new FormControl('1'),

  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

    private _route: ActivatedRoute

  ) { 
    Chart.register(...registerables);
    Chart.register(zoomPlugin);
  }

  ngOnInit(): void {

    this._route.url.pipe(pluck(0, 'path')).subscribe((segment: any) => {

      // ? *** نمودار کیفی رانندگان  ***

      if (segment == 'quality-chart-drivers') {

        this.bCharts = true;

      }

      // ? *** وضعیت سفرها ***

      else {

      }

    })

    this.getDomain();

  }

  filter_list(val: any) {

    this.list_Trips = this.list_Trips_Search.filter((el: any) => {

      return el.strMobileDomain_strComment.includes(val.value)

    });

    if (val.value.trim() == '') {

      this.list_Trips = this.list_Trips_Search;

    }

  }

  async getDomain() {

    let res = JSON.parse((await axios.post(`MobileDomain_List`, {})).data.toString());

    this.lst_Domain = res;

  }

  async searchTrip() {

    // نمودار کیفی رانندگان

    if (this.bCharts) {

      this._otherService.Showspinner();

      let res_1 = JSON.parse((await axios.post(`Peysepar_Dashboard_TripCountBaseMobile_Total`, this._otherService.stringNumberToNumber(this.searchModel.value))).data.toString());

      let res_2 = JSON.parse((await axios.post(`Peysepar_Dashboard_TripScoreBaseMobile_Total`, this._otherService.stringNumberToNumber(this.searchModel.value))).data.toString());

      this._otherService.nonespinner();

      if (res_1.iResult == 0) return this._tooltip.showError(res_1.strError);

      if (res_2.iResult == 0) return this._tooltip.showError(res_2.strError);

      this.get_Chart1(res_1);

      this.get_Chart2(res_2);

    }

    // وضعیت سفرها

    else {

      this._otherService.Showspinner();

      let res = JSON.parse((await axios.post(this.bCharts ? `Peysepar_Dashboard_TripCountBaseMobile_Total` : `OffitialTrip_TiipStatus`, this._otherService.stringNumberToNumber(this.searchModel.value))).data.toString());

      this._otherService.nonespinner();

      if (res.iResult == 0) return this._tooltip.showError(res.strError);

      this.trip_Obj = {

        iTotal: 0, // تعداد کل

        iRegistered: 0, // ثبت شده	

        iConfirmed: 0, // تایید شده		

        iDriverAssignment: 0, // اختصاص راننده		

        iInProgress: 0, // در حال انجام		

        iDdone: 0, // انجام‌شده		

        iCanceled: 0, // لغو شده		

        iMission: 0, // ماموریتی

      }

      this.list_Trips = res;

      this.list_Trips_Search = res;

      this.list_Trips.forEach((el: any) => {

        this.trip_Obj = {

          iTotal: this.trip_Obj?.iTotal + el.iTotal,

          iRegistered: this.trip_Obj?.iRegistered + el.iRegistered,

          iConfirmed: this.trip_Obj?.iConfirmed + el.iConfirmed,

          iDriverAssignment: this.trip_Obj?.iDriverAssignment + el.iDriverAssignment,

          iInProgress: this.trip_Obj?.iInProgress + el.iInProgress,

          iDdone: this.trip_Obj?.iDdone + el.iDdone,

          iCanceled: this.trip_Obj?.iCanceled + el.iCanceled,

          iMission: this.trip_Obj?.iMission + el.iMission,

        }

      })

    }

  }

  get_Chart1(res: any[]) {

    let label: Array<any> = [];

    let dataChart: Array<any> = [];

    res.forEach((element: any) => {

      label.push(element.X);

      dataChart.push(element.Y);

    });

    var canvas = document.getElementById("myChart1") as any;

    if (this.chart1) this.chart1.destroy();

    var ctx = canvas.getContext("2d");

    this.chart1 = new Chart(ctx, {

      type: 'bar',

      data: {

        labels: label,

        datasets: [

          {
            label: '',

            data: dataChart,

            backgroundColor: Object.values(this.CHART_COLORS3),

          },

        ],

      },

      options: {
                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                family: "vazir",
                size: 12
              }
            }
          }
        }
      },
    });


  }

  get_Chart2(res: any[]) {

    let label: Array<any> = [];

    let dataChart: Array<any> = [];

    res.forEach((element: any) => {

      label.push(element.X);

      dataChart.push(element.Y);

    });

    var canvas = document.getElementById("myChart2") as any;

    if (this.chart2) this.chart2.destroy();

    var ctx = canvas.getContext("2d");

    this.chart2 = new Chart(ctx, {

      type: 'bar',

      data: {

        labels: label,

        datasets: [

          {
            label: '',

            data: dataChart,

            backgroundColor: Object.values(this.CHART_COLORS3),


          },

        ],

      },

      options: {
                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                family: "vazir",
                size: 12
              }
            }
          }
        }
      },
    });


  }

  exportexcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'وضعیت سفرها.xlsx');
  }

}
